import MuiSwitch from "@mui/material/Switch";

export default function Switch(props) {
  return <MuiSwitch {...props} />;
}
